import {gql} from "@apollo/client";

export const getMenus = gql`
  query getMenusList {
    menus {
      id
      name
      image
      details
      platesCount
    }
  }
`

export const getMenuById = gql`
  query menuById($id: ID!) {
    menu( id: $id) {
      id
      name
      image
      details
      platesCount
      clientId
      client { id, fullName }
    }
  }
`

export const getClientMenus = gql`
  query getClientMenus($clientId: ID!) {
    clientMenus(clientId: $clientId) {
      id
      name
      image
      details
      platesCount
      parentMenuId
      status
    }
  }
`

export const getClientComments = gql`
  query getClientComments($clientId: ID!) {
    clientComments(clientId: $clientId) {
      menu {id, name, image}
      plate {id, name, image}
      comment
      createdAt
    }
  }
`

export const getClientRatings = gql`
  query getClientRatings($clientId: ID!) {
    clientRatings(clientId: $clientId) {
      menu {id, name, image}
      plate {id, name, image}
      rating
      createdAt
    }
  }
`

export const getMenuPlates = gql`
  query menuPlates($menuId: ID!) {
    menuItems( menuId: $menuId) {
      id
      day
      menuId
      menu {id, name}
      category {id, name, time}
      plate {id, name, image}
      history { id }
    }
  }
`

export const createMenuMutation = gql`
  mutation createMenu($name: String!, $details: String, $image: String){
    createMenu(
      input: {
        name: $name,
        details: $details,
        image: $image,
      }) {
      menu {
        id
      }
    }
  }
`

export const updateMenuMutation = gql`
  mutation updateMenu(
    $id: ID!, $name: String!, $details: String, $image: String
  ){
    updateMenu(
      input: {
        id: $id,
        name: $name,
        details: $details,
        image: $image,
      }) {
      menu {
        id
      }
    }
  }
`

export const deleteMenuMutation = gql`
  mutation deleteMenu($id: ID!){
    deleteMenu(
      input: {id: $id}) {
      menu {
        id
      }
    }
  }
`

export const AddMenuPlateMutation = gql`
  mutation addMenuItem($id: ID, $menuId: ID!, $plateId: ID!, $categoryId: ID!, $day: String!){
    addMenuItem(
      input: {
        id: $id,
        menuId: $menuId,
        plateId: $plateId,
        categoryId: $categoryId,
        day: $day,
      }
    ){
      menuItem{
        id
      }
    }
  }
`

export const UpdateMenuPlateMutation = gql`
  mutation updateMenuItem($id: ID, $menuId: ID!, $plateId: ID!, $categoryId: ID!, $day: String!){
    updateMenuItem(
      input: {
        id: $id,
        menuId: $menuId,
        plateId: $plateId,
        categoryId: $categoryId,
        day: $day,
      }
    ){
      menuItem{
        id
      }
    }
  }
`

export const deleteMenuPlateMutation = gql`
  mutation deleteMenuItem($id: ID!){
    deleteMenuItem(
      input: {id: $id}) {
      menuItem {
        id
      }
    }
  }
`